import {
  CreateTransactionPayload,
  InitializeWalletPinResetResponse,
  ResetWalletPinPayload,
  ResetWalletPinResponse,
} from "@/types/transactions";
import {
  GetVirtualAccountResponse,
  GetWalletResponse,
  SetupVirtualAccount,
} from "@/types/wallet";
import { axiosWithToken } from "@/utils/axios";
import { AxiosRequestConfig, AxiosResponse } from "axios";

class ServiceClass {
  // Transaction - CREATE INTERNAL LEDGER RECORD
  CreateNewTransaction(payload: CreateTransactionPayload) {
    return axiosWithToken().post("/transactions", payload);
  }

  InitiateTransaction(payload: {
    customerEmail?: string;
    amount: number;
    callback_url: string;
  }) {
    return axiosWithToken().post("/transactions/initiate", {
      ...payload,
    });
  }

  GetBanks() {
    return axiosWithToken().get("/providers/banks");
  }

  GetUserBundleBalance() {
    return axiosWithToken().get("/user/bundle_balance");
  }

  GetBeneficiaries() {
    return axiosWithToken().get("/beneficiaries");
  }

  GetUserAccount(): Promise<AxiosResponse<GetVirtualAccountResponse>> {
    return axiosWithToken().get("/account/user");
  }

  GetWallet(): Promise<AxiosResponse<GetWalletResponse>> {
    return axiosWithToken().get("/wallet");
  }

  createWallet(): Promise<
    AxiosResponse<{
      status: string;
      message: string;
      data: any;
    }>
  > {
    return axiosWithToken().post("/wallet", {});
  }
  beginVirtualAccountSetup(
    payload: SetupVirtualAccount,
  ): Promise<AxiosResponse<any>> {
    return axiosWithToken().post(
      "/providers/virtual-account/initialize",
      payload,
    );
  }

  setWalletPin(payload: {
    pin: string;
    confirm_pin: string;
  }): Promise<AxiosResponse<any, any>> {
    return axiosWithToken().post("/wallet/pin", payload);
  }

  initializeWalletPinReset(): Promise<
    AxiosResponse<InitializeWalletPinResetResponse>
  > {
    return axiosWithToken().post("/wallet/pin/reset/initialize");
  }

  resetWalletPin(
    payload: ResetWalletPinPayload,
  ): Promise<AxiosResponse<ResetWalletPinResponse>> {
    return axiosWithToken().post("/wallet/pin/reset", payload);
  }

  ReconcileCustomerValidationStatus(customer_code: string) {
    return axiosWithToken().get("/providers/virtual-account/status", {
      params: {
        customer_code,
      },
    });
  }

  ReconcileMissingVirtualAccount(customer_code: string) {
    return axiosWithToken().get("/providers/virtual-account/sync", {
      params: {
        customer_code,
      },
    });
  }

  GetTransactions({ params }: any) {
    return axiosWithToken().get("/transactions", { params });
  }

  CheckTransactionStatus(transactionReference: string) {
    return axiosWithToken().post(
      `/transactions/status/${transactionReference}`,
    );
  }

  GetTransactionByReference(transactionReference: string) {
    return axiosWithToken().get(`/transactions/${transactionReference}`);
  }

  CreateVirtualAccount(payload: any) {
    return axiosWithToken().post("/providers/setup_virtual_account", {
      ...payload,
    });
  }

  DebitFNP(payload: any) {
    return axiosWithToken().post("/transactions/debit-fnp", {
      ...payload,
    });
  }

  DebitUser(payload: any) {
    return axiosWithToken().post("/transactions/debit", {
      ...payload,
    });
  }

  AddBeneficiaries(payload: any) {
    return axiosWithToken().post("/beneficiaries", {
      ...payload,
    });
  }

  ResolveAccount(payload: any) {
    return axiosWithToken().post("/providers/resolve_account", {
      ...payload,
    });
  }
}

const TransactionsService = new ServiceClass();
export default TransactionsService;
